<template>
  <pt-modal ref="deleteModal" :close-on-outside-click="false" size="medium">
    <div slot="modal-body" class="flex flex-col items-center">
      <div class="flex flex-col items-center">
        <img src="@assets/images/ic_delete.svg" alt="delete" />
        <div class="font-bold text-lg text-black mb-1">
          Delete
        </div>
        <div class="font-medium text-base text-center text-grey-dark mb-6">
          {{ bodyText ? bodyText : 'Are you sure you want to delete?' }}
        </div>
      </div>
      <div class="flex flex-row">
        <pt-button :disabled="disabled" variant="primary-outline" size="sm" class="w-1/2 mr-2" @action="confirm">
          Yes
        </pt-button>
        <pt-button :disabled="disabled" variant="secondary-outline" size="sm" class="w-1/2" @action="cancel">
          Cancel
        </pt-button>
      </div>
    </div>
  </pt-modal>
</template>

<script>
import { PtModal } from '@pathao/ui-components/esm/Modal';
import { PtButton } from '@pathao/ui-components';
export default {
  name: 'DeleteModal',
  components: {
    PtModal,
    PtButton,
  },
  props: {
    bodyText: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    showModal() {
      this.$refs.deleteModal.showModal();
    },
    closeModal() {
      this.$refs.deleteModal.closeModal();
    },
    confirm() {
      this.$refs.deleteModal.closeModal();
      this.$emit('onConfirm');
    },
    cancel() {
      this.$refs.deleteModal.closeModal();
      this.$emit('onCancel');
    },
  },
};
</script>
